module.exports = __webpack_public_path__ + "8813b12be0666c5bad85e1d103761570.png";